/**
 * UiBlocks price formatters and calculators
 *
 * Currency is hardcoded to Lei (RON).
 */
import { LABELS } from './labels'

/**
 * Format price as string (e.g., "1234.56 Lei")
 *
 * Simple string format for strikethrough/MSRP display.
 * For the main price display with split decimals, use PriceDisplay component.
 */
export function formatPrice(price: number): string {
  if (!Number.isFinite(price)) return `0.00 ${LABELS.CURRENCY}`
  const parts = price.toFixed(2).split('.')
  return `${parts[0]}.${parts[1]} ${LABELS.CURRENCY}`
}

/**
 * Split price into integer and decimal parts
 * Used by PriceDisplay component for split decimal styling.
 */
export function formatPriceParts(price: number): { integer: string; decimal: string } {
  if (!Number.isFinite(price)) return { integer: '0', decimal: '00' }
  const parts = price.toFixed(2).split('.')
  return { integer: parts[0], decimal: parts[1] }
}

/**
 * Calculate discount amount between regular and special price
 */
export function calculateDiscount(
  regularPrice: number,
  specialPrice: number | null | undefined
): number {
  if (!specialPrice || specialPrice >= regularPrice) return 0
  return regularPrice - specialPrice
}

/**
 * Calculate discount percentage between regular and special price
 */
export function calculateDiscountPercentage(
  regularPrice: number,
  specialPrice: number | null | undefined
): number {
  if (!specialPrice || !regularPrice || specialPrice >= regularPrice) return 0
  return ((regularPrice - specialPrice) / regularPrice) * 100
}
